import { useContext } from "react";
import { AppContext } from "../App";
import { FaArrowRight } from "react-icons/fa";
import { HiOutlineShieldCheck } from "react-icons/hi";

export default function OneService({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "view",
      subItem: "policy",
      extraItem: data.uuid,
    });
  }

  // Get the first letter of the appName for the placeholder
  const initial = data?.appName ? data.appName.charAt(0).toUpperCase() : "P";

  return (
    <div
      className="policy-card-container"
      style={{
        cursor: "pointer",
        borderRadius: "16px",
        overflow: "hidden",
        background: "#fff",
        position: "relative",
        border: "1px solid #f0f0f0",
        boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
        transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
      }}
      onClick={view}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px)";
        e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.08)";
        e.currentTarget.style.borderColor = "var(--primaryColor)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.04)";
        e.currentTarget.style.borderColor = "#f0f0f0";
      }}
    >
      {/* --- Stylized Initial Section (Replaces Image) --- */}
      <div
        style={{
          width: "100%",
          height: "160px",
          background: `linear-gradient(135deg, var(--primaryColor) 0%, var(--secondaryColor) 100%)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {/* Large Decorative Initial */}
        <span 
          style={{ 
            fontSize: "72px", 
            fontWeight: "800", 
            color: "rgba(255,255,255,0.25)",
            userSelect: "none"
          }}
        >
          {initial}
        </span>

        {/* Floating Badge */}
        <div 
            className="position-absolute shadow-sm d-flex align-items-center justify-content-center"
            style={{ 
                bottom: "-20px", 
                right: "20px",
                width: "44px", 
                height: "44px", 
                backgroundColor: "#fff", 
                borderRadius: "12px",
                color: "var(--primaryColor)"
            }}
        >
            <HiOutlineShieldCheck size={24} />
        </div>
      </div>

      {/* --- Content Section --- */}
      <div style={{ padding: "35px 20px 25px 20px" }}>
        <h6
          className="font-bold text-secondary mb-2"
          style={{
            fontSize: "17px",
            lineHeight: "1.3",
            letterSpacing: "-0.01em"
          }}
        >
          {data.appName} Policy
        </h6>

        <p className="text-muted mb-4" style={{ fontSize: "13.5px", lineHeight: "1.5" }}>
          Official regulatory guidelines for {data.appName}. Click to view full details and compliance status.
        </p>

        <div 
            className="d-flex align-items-center justify-content-between"
            style={{ 
                fontSize: "13px", 
                fontWeight: "700",
                color: "var(--primaryColor)",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
            }}
        >
            <span>Read Policy</span>
            <FaArrowRight size={12} />
        </div>
      </div>

      {/* Thin subtle progress-style accent at bottom */}
      <div style={{ height: "3px", width: "30%", background: "var(--primaryColor)", margin: "0 auto", borderRadius: "10px 10px 0 0", opacity: 0.6 }} />
    </div>
  );
}